<template>
  <div id="product-fittings-table">
    <div class="table-wrapper">
      <span class="table-name">{{$t('product_fittings_table.sashes')}}</span>
      <div class="rTable">
        <div class="rTableRow problem-header">
          <div
            class="rTableHead text-cell"
            v-for="(header, i) in headers"
            :key="i"
            :style="{ 'width': header.width + '%'}"
          >{{header.text}}</div>
          <div
            class="rTableHead text-cell"
            v-for="(header, i) in fieldsHeaders"
            :key="i+1000"
            :style="{ 'width': header.width + '%'}"
          >{{header.text}}</div>
        </div>
        <div
          class="rTableRow"
          :class="{ 'highlighted-row': fittingGroup.highlighted}"
          v-for="(fittingGroup, i ) in product.fitting_groups"
          :key="i"
        >
          <div class="rTableCell">{{i+1}}.</div>
          <div class="rTableCell">{{fittingGroup.code}}</div>
          <div class="rTableCell">{{fittingGroup.getFitting().description}}</div>
          <div
            class="rTableCell number-cell"
            v-for="(field, i) in fieldsHeaders"
            :key="i"
          >{{fittingGroup.getFieldQuantity(field.text)}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "product-fittings-table",
  props: ["product"],
  data() {
    return {
      loading: false,
      fieldsHeaders: [],
      headers: [
        {
          text: this.$t("product_fittings_table.number"),
          width: 5
        },
        {
          text: this.$t("product_fittings_table.code"),
          width: 25
        },
        {
          text: this.$t("product_fittings_table.description"),
          width: 40
        }
      ]
    };
  },
  created() {
    this.initialize();
  },
  watch: {
    product: {
      handler() {
        this.initialize();
      },
      deep: true
    }
  },
  methods: {
    initialize() {
      this.getHeaders();
    },

    getHeaders() {
      const headers = [];
      const fieldsSet = new Set();
      this.product.fitting_groups.forEach(fittingGroup => {
        fittingGroup.fittings.forEach(fitting => {
          fieldsSet.add(fitting.field);
        });
      });
      const fields = [...fieldsSet].sort((a, b) => {
        if (a < b) {
          return -1;
        }
        if (a > b) {
          return 1;
        }
        return 0;
      });
      const fieldWidth = 30 / fields.length;
      fields.forEach(field => {
        headers.push({
          text: field,
          width: fieldWidth
        });
      });
      this.fieldsHeaders = headers;
    },

  }
};
</script>

<style scoped>
.highlighted-row {
  background: #14c944;
}
</style>